import types from '../../types';

const withdrawals = (state = { loading: true }, { type, payload }) => {
  switch (type) {
    case types.GET_WITHDRAWALS_START:
      return { ...state, loading: true };

    case types.GET_WITHDRAWALS_SUCCESS:
      return { ...payload, loading: false };

    case types.GET_WITHDRAWALS_FAILURE:
      return { ...state, loading: false };

    default:
      return state;
  }
};

export default withdrawals;
